var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"cursor-pointer flex-shrink-0",class:[_vm.size],attrs:{"tag":"div","to":`/products/${_vm.productKey}`}},[_c('img',{attrs:{"src":`/logos/${_vm.productKey}.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }